import { render, staticRenderFns } from "./IButton.vue?vue&type=template&id=72176cd7&scoped=true&"
import script from "./IButton.vue?vue&type=script&lang=js&"
export * from "./IButton.vue?vue&type=script&lang=js&"
import style0 from "./IButton.vue?vue&type=style&index=0&id=72176cd7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72176cd7",
  null
  
)

export default component.exports